import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import OurStrategy from "@/pages/OurStrategy";
import YourGoals from "@/pages/YourGoals";
import WhyInflation from "@/pages/WhyInflation";
import Resources from "@/pages/Resources";
import AboutUs from "@/pages/AboutUs";
import Contact from "@/pages/Contact";
import Grievance from "@/pages/Grievance";
import Snapshot from "@/pages/Snapshot";
import Compass from "@/pages/Compass";
import Regulatory from "@/pages/Regulatory";
import Journal from "@/pages/journal/Journal";
import JournalPost from "@/pages/journal/JournalPost";
import AdminLogin from "@/pages/journal/AdminLogin";
import AdminCallback from "@/pages/journal/AdminCallback";
import AdminDashboard from "@/pages/journal/AdminDashboard";
import AdminEditor from "@/pages/journal/AdminEditor";
import AdminCompass from "@/pages/journal/AdminCompass";
import AdminRoute from "@/components/journal/AdminRoute";
import { Toaster } from "@/components/ui/sonner";
import { ThemeProvider } from "@/lib/theme";
import { AuthProvider } from "@/lib/auth";
import { useLocation } from "react-router-dom";

// Detect OAuth callback fragment BEFORE normal routing (critical race-condition fix)
function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AdminCallback />;
  }
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path="/" element={<Home />} />
        <Route path="/our-strategy" element={<OurStrategy />} />
        <Route path="/your-goals" element={<YourGoals />} />
        <Route path="/why-inflation-matters" element={<WhyInflation />} />
        <Route path="/resources" element={<Resources />} />
        <Route path="/about" element={<AboutUs />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/grievance-redressal" element={<Grievance />} />
        <Route path="/snapshot" element={<Snapshot />} />
        <Route path="/compass" element={<Compass />} />
        <Route path="/regulatory" element={<Regulatory />} />
        <Route path="/journal" element={<Journal />} />
        <Route path="/journal/admin/login" element={<AdminLogin />} />
        <Route path="/journal/admin" element={<AdminRoute><AdminDashboard /></AdminRoute>} />
        <Route path="/journal/admin/new" element={<AdminRoute><AdminEditor /></AdminRoute>} />
        <Route path="/journal/admin/edit/:id" element={<AdminRoute><AdminEditor /></AdminRoute>} />
        <Route path="/journal/admin/compass" element={<AdminRoute><AdminCompass /></AdminRoute>} />
        <Route path="/journal/:slug" element={<JournalPost />} />
      </Route>
    </Routes>
  );
}

function App() {
  return (
    <HelmetProvider>
      <ThemeProvider>
        <AuthProvider>
          <div className="App">
            <BrowserRouter>
              <AppRouter />
            </BrowserRouter>
            <Toaster richColors position="top-right" />
          </div>
        </AuthProvider>
      </ThemeProvider>
    </HelmetProvider>
  );
}

export default App;
